import React, { useState } from "react";
import { Link } from "react-router-dom";

import { GetReportFood } from "./../../api/food";

const ReportFood = ({ token }) => {
  const [dates, setDates] = useState({ startDate: null, endDate: null });

  async function donwloadRepost() {
    const response = await GetReportFood(token, dates.startDate, dates.endDate);

    // Получаем blob из данных ответа axios
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Создание URL для blob
    const url = window.URL.createObjectURL(blob);

    // Создание временной ссылки для скачивания
    const link = document.createElement("a");
    link.href = url;

    // Получение имени файла из headers
    const contentDisposition = response.headers["content-disposition"];
    let filename = "food_report.xlsx";

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1];
      }
    }

    link.download = filename;

    // Автоматическое скачивание
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Очистка URL
    window.URL.revokeObjectURL(url);
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-4">
          <input
            className="form-control"
            type="date"
            name=""
            id=""
            onChange={(e) =>
              setDates({ startDate: e.target.value, endDate: dates.endDate })
            }
            value={dates.startDate}
          />
          <input
            className="form-control"
            type="date"
            name=""
            id=""
            onChange={(e) =>
              setDates({ startDate: dates.startDate, endDate: e.target.value })
            }
            value={dates.endDate}
          />
          <button className="btn" onClick={donwloadRepost}>
            Скачать
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportFood;
